import React, { useState } from 'react';
import { useWindowSize } from '../hooks/useWindowSize';

const useHasAgreedToCookieConsentBanner = () => {
  const [
    cookieConsentBannerResponse,
    setCookieConsentBannerResponse
  ] = useState(window.localStorage.getItem('hasAgreedToCookieConsentBanner'));

  return {
    setHasAgreedToCookieConsentBanner: () => {
      window.localStorage.setItem('hasAgreedToCookieConsentBanner', 'true');
      setCookieConsentBannerResponse('true');
    },
    setHasDeclinedToCookieConsentBanner: () => {
      window.localStorage.setItem('hasAgreedToCookieConsentBanner', 'false');
      setCookieConsentBannerResponse('false');
    },
    hasDismissedCookieConsentBanner: cookieConsentBannerResponse !== null
  };
};

const Contents = () => (
  <>
    This website uses cookies to enhance user experience, to analyze performance
    and traffic on our website. We also share information about your use of our
    site with our social media, advertising and analytics partners. By clicking
    ACCEPT ALL or continuing to browse this Platform (more than one click), you
    are agreeing to our use of cookies and sharing of information about your use
    of our site with our social media, advertising and analytics partners.
    Further information is available in our&nbsp;
    <a href="/privacy-policy.html">Cookie Policy</a>
    &nbsp;&nbsp;
    <a href="/privacy-policy.html#what-do-we-use-information-for">
      Do Not Sell Share My Personal Information
    </a>
  </>
);

const AcceptAll = ({ className, onClick }) => (
  <button
    className={`p-2 ${className} rounded bg-blue-dark text-white text-center`}
    type="button"
    onClick={onClick}
  >
    ACCEPT ALL
  </button>
);

const Decline = ({ className, onClick }) => (
  <button
    className={`p-2 ${className} rounded text-blue-dark text-center`}
    type="button"
    onClick={onClick}
  >
    DECLINE
  </button>
);

const CookieConsentBanner = () => {
  const {
    hasDismissedCookieConsentBanner,
    setHasAgreedToCookieConsentBanner,
    setHasDeclinedToCookieConsentBanner
  } = useHasAgreedToCookieConsentBanner();

  const [isHeightCollapsed, setIsHeightCollapsed] = useState(true);

  const { width } = useWindowSize();

  if (hasDismissedCookieConsentBanner) {
    return null;
  }

  // desktop view
  if (width > 768) {
    return (
      <div className="cookie-consent-banner fixed z-50 w-full px-6 py-3 flex">
        <div className="flex-grow content-center">
          <p className="text-sm">
            <Contents />
          </p>
        </div>
        <div className="flex-auto content-center pl-2">
          <AcceptAll
            className="mx-2 my-0"
            onClick={setHasAgreedToCookieConsentBanner}
          />
          <Decline
            className="mx-2 my-0"
            onClick={setHasDeclinedToCookieConsentBanner}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className="cookie-consent-banner cookie-consent-banner-small-viewport fixed z-50 w-full px-6 py-3 flex flex-col"
      style={{ maxHeight: isHeightCollapsed ? '15%' : undefined }}
    >
      {isHeightCollapsed && (
        <div
          style={{
            position: 'absolute',
            background:
              'linear-gradient(' +
              'to bottom, ' +
              'rgba(222, 238, 255, 0.25) 0%, ' +
              'rgba(222, 238, 255, 0.55) 25%, ' +
              'rgba(222, 238, 255, 0.9) 100%' +
              ')',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }}
          onClick={() => setIsHeightCollapsed(false)}
        >
          <span
            style={{
              position: 'absolute',
              bottom: 20,
              left: 0,
              right: 0,
              textAlign: 'center'
            }}
          >
            &#8964; see more &#8964;
          </span>
        </div>
      )}

      <p className="text-sm mb-4 text-justify">
        <Contents />
      </p>
      <AcceptAll className="m-2" onClick={setHasAgreedToCookieConsentBanner} />
      <Decline className="mx-2" onClick={setHasDeclinedToCookieConsentBanner} />
    </div>
  );
};

export default CookieConsentBanner;
